import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { BillAccountsSelectors } from '@amfam/billing/billaccount/data-access';
import {
  PaymentMethodAccountType,
  PaymentMethodAddEditConfig
} from '@amfam/billing/payment-method/util';

@Component({
  selector: 'ds-payment-method-modal',
  templateUrl: './payment-method-modal.component.html',
  styleUrls: ['./payment-method-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaymentMethodModalComponent implements OnInit {
  @Input() paymentMethodAddEditConfig: PaymentMethodAddEditConfig;
  @Input() displayDiscountWarning = false;
  @Input() showTryAgainButton = false;
  @Output() paymentMethodAddEditCompleteEvent: EventEmitter<string> = new EventEmitter<string>();

  paymentMethodTypes = PaymentMethodAccountType;
  isHsPolicy$: Observable<boolean>;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.isHsPolicy$ = this.store.select(BillAccountsSelectors.selectIsSelectedBillPolicyHomesite);
  }
}
